<template>
  <b-card
    no-body
    class="p-2 set-banner-card container-card"
  >
    <div
      no-body
      class="set-banner-card"
    >
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-end"
        >
          <add-button
            v-if="getPermissionModule('Banner').adjust"
            btn-label="Banner Group"
            @click.native="$router.push('/banner/group/Banner_Group/create')"
          />
        </b-col>
        <b-col
          cols="12"
          class="d-flex justify-content-end my-1"
        >
          <div class="banner-search-container">
            <search :on-search-input="onSearchGroupBanner" />
          </div>
        </b-col>
        <div class="content-banner-group-table">
          <overlay-loading :loading="loading.api">
            <template #content>
              <!-- <b-table
                :fields="fields.bannerGroup"
                :items="groupBannerTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                no-local-sorting
                show-empty
                class="banner-group-table"
                @sort-changed="sortingChanged"
              > -->
              <b-table
                :fields="fields.bannerGroup"
                :items="groupBannerTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                no-local-sorting
                show-empty
                class="default-static-table-vertical"
                @sort-changed="sortingChanged"
              >
                <template #cell(seq)="data">
                  <span>{{ data.item.group_banner.seq }}</span>
                </template>
                <template #cell(group_banner_name)="data">
                  <span>{{ data.item.group_banner.group_name }}</span>
                </template>
                <template #cell(description)="data">
                  <div class="banner-group-table-description">
                    {{ data.item.group_banner.description || '-' }}
                  </div>
                </template>
                <template #cell(valid_from)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.group_banner.valid_from)
                  }}</span>
                </template>
                <template #cell(valid_through)="data">
                  <span>{{
                    resolveDateWithSeperator(
                      data.item.group_banner.valid_through,
                    )
                  }}</span>
                </template>
                <template #cell(latest_update)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.group_banner.update_time)
                  }}</span>
                </template>
                <template #cell(status)="data">
                  <div
                    v-if="data.item.group_banner.status"
                    class="d-flex align-items-center"
                  >
                    <feather-icon
                      icon="CircleIcon"
                      class="active-icon mr-2"
                    />

                    <span>{{
                      resolveBannerStatusLabel(data.item.group_banner.status)
                    }}</span>
                  </div>
                  <div
                    v-else
                    class="d-flex align-items-center"
                  >
                    <feather-icon
                      icon="CircleIcon"
                      class="inActive-icon mr-2"
                    />
                    <span class="inActive-label">{{
                      resolveBannerStatusLabel(data.item.group_banner.status)
                    }}</span>
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div class="d-flex justify-content-start align-items-center">
                    <b-button
                      v-if="getPermissionModule('Banner').adjust"
                      v-b-tooltip.hover
                      variant="secondary"
                      class="banner-action mr-4"
                      title="Edit"
                      @click="
                        $router.push(
                          `/banner/group/Banner_Group/${row.item.group_banner.group_banner_id}/info`,
                        )
                      "
                    >
                      <edit-icon class="banner-group-action-svg iconEdit-btn" />
                    </b-button>

                    <delete-button
                      v-if="getPermissionModule('Banner').adjust"
                      v-b-tooltip.hover
                      icon
                      class="mr-4"
                      title="Delete"
                      @onClick="openDeleteWarningModal(row.item, $event)"
                    />
                    <b-button
                      v-if="!row.item.mapping_banners.length == 0"
                      v-b-tooltip.hover
                      variant="secondary"
                      class="banner-action ml-4 mr-4 iconSvg-btn"
                      title="Show more"
                      @click="onExpandTable(row)"
                    >
                      <expand-icon
                        class="banner-group-action-svg"
                        :class="row.detailsShowing ? 'active' : ''"
                      />
                    </b-button>
                  </div>
                </template>
                <template #row-details="row">
                  <div>
                    <b-table
                      :fields="fields.bannerGroupDetail"
                      :items="row.item.mapping_banners"
                      responsive
                      bordered
                      borderless
                      sticky-header
                      class="banner-group-table-inside"
                    >
                      <template #cell(no)="data">
                        <span>{{ data.index + 1 }}</span>
                      </template>
                      <template #cell(banner_image_url)="data">
                        <div
                          v-if="data.item.banner_image_url"
                          class="col-img"
                        >
                          <img
                            :src="data.item.banner_image_url"
                            :alt="`${data.item.banner_name} image`"
                            class="col-img-item"
                            draggable="false"
                          >
                        </div>
                        <div v-else>
                          -
                        </div>
                      </template>
                      <template #cell(set_name)="data">
                        <span>{{ data.item.set_name || '-' }}</span>
                      </template>
                      <template #cell(banner_name)="data">
                        <span>{{ data.item.banner_name || '-' }}</span>
                      </template>
                      <template #cell(call_to_action)="data">
                        <span>{{ data.item.call_to_action || '-' }}</span>
                      </template>
                      <template #cell(valid_from)="data">
                        <span>{{
                          resolveDateWithSeperator(data.item.valid_from)
                        }}</span>
                      </template>
                      <template #cell(valid_through)="data">
                        <span>{{
                          resolveDateWithSeperator(data.item.valid_through)
                        }}</span>
                      </template>
                      <template #cell(latest_update)="data">
                        <span>{{
                          data.item.updated_time
                            ? resolveDateWithSeperator(data.item.updated_time)
                            : resolveDateWithSeperator(data.item.update_time)
                        }}</span>
                      </template>
                      <template #cell(status)="data">
                        <div
                          v-if="
                            data.item.status ||
                              data.item.banner_status == 'Active'
                          "
                          class="d-flex align-items-center"
                        >
                          <feather-icon
                            icon="CircleIcon"
                            class="active-icon mr-2"
                          />

                          <span>{{
                            data.item.banner_status ||
                              resolveBannerStatusLabel(data.item.status)
                          }}</span>
                        </div>
                        <div
                          v-else
                          class="d-flex align-items-center"
                        >
                          <feather-icon
                            icon="CircleIcon"
                            class="inActive-icon mr-2"
                          />
                          <span class="inActive-label">
                            {{
                              data.item.banner_status ||
                                resolveBannerStatusLabel(data.item.status)
                            }}
                          </span>
                        </div>
                      </template>
                      <template #cell(actions)="data">
                        <div v-if="getPermissionModule('Banner').adjust" class="d-flex justify-content-center">
                          <b-button
                            v-b-tooltip.hover
                            title="Edit"
                            variant="secondary"
                            class="banner-action mr-2"
                            @click="
                              data.item.banner_id
                                ? $router.push(
                                  `/banner/group/Banner_Group/banner/info/${data.item.banner_id}`,
                                )
                                : $router.push(
                                  `/banner/group/Banner_Group/set/${data.item.set_banner_id}/info`,
                                )
                            "
                          >
                            <edit-icon
                              class="banner-group-action-svg iconEdit-btn"
                            />
                          </b-button>
                          <b-button
                            v-b-tooltip.hover
                            title="Delete"
                            variant="secondary"
                            class="banner-action mr-2"
                            @click="removeMappingBanner(data.item)"
                          >
                            <delete-icon class="banner-group-action-svg" />
                          </b-button>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>

          <div class="block-bg-table" />
        </div>
        <div class="content-pagination-banner-group-table">
          <pagination-with-reorder
            :pagination="pagination"
            @pageChange="onPageChange"
          />
        </div>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BTable, BRow, BCol, BCard, BButton, BSpinner,
} from 'bootstrap-vue'
import EditIcon from '@/@core/components/svg/common/Edit.vue'
import ExpandIcon from '@/@core/components/svg/common/IconExpandTable.vue'
import DeleteIcon from '@/@core/components/svg/common/Trash.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'

import AddButton from '@/views/components/button/AddButton.vue'
import DeleteButton from '@/views/components/button/DeleteButton.vue'
import Search from '@/views/components/search/Search.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useBannerGroup from './hooks/useBannerGroup'

export default {
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BButton,
    BSpinner,
    EditIcon,
    DeleteIcon,
    ExpandIcon,
    AddButton,
    Search,
    CardNoItem,
    DeleteButton,
    PaginationWithReorder,
  },

  setup() {
    const {
      fields,
      groupBannerTable,
      groupBannerActionList,
      pagination,
      loading,
      resolveDateWithSeperator,
      resolveBannerStatusLabel,
      resolveBannerAction,
      onSearchGroupBanner,
      onPageChange,
      sortingChanged,
      removeMappingBanner,
      onExpandTable,
      onDeleteBannerGroup,
      openDeleteWarningModal,
      getPermissionModule
    } = useBannerGroup()

    return {
      fields,
      groupBannerTable,
      groupBannerActionList,
      pagination,
      loading,
      resolveDateWithSeperator,
      resolveBannerStatusLabel,
      resolveBannerAction,
      onSearchGroupBanner,
      onPageChange,
      sortingChanged,
      removeMappingBanner,
      onExpandTable,
      onDeleteBannerGroup,
      openDeleteWarningModal,
      getPermissionModule
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/pages/banner/banner-table.css';
@import '~@/assets/css/pages/banner/banner-group.css';
@import '~@/assets/css/override-styles/status.css';
</style>
